// extracted by mini-css-extract-plugin
export default {"closeButton":"BrandedModalHeader_closeButton__C90Tl","header":"BrandedModalHeader_header__+ki6m","logo":"BrandedModalHeader_logo__VQ5OE"};